import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Unit policy (owner decision 2026-02): MILES everywhere in UI.
// The API keeps its internal/legacy `distance_km` fields; convert at display.
export function kmToMiles(km) {
  return Math.round(km * 0.621371 * 10) / 10;
}
